const DownloadUrlPrefix = `/api/Tutorials/GetBlobFileContent?blobItemPath=`;

export const AdminTutorialVideo = `${DownloadUrlPrefix}${encodeURIComponent('adminTest.mp4')}`;
export const ProjectAnalyticsTutorialVideo = `${DownloadUrlPrefix}${encodeURIComponent('projectanalyticsTest.mp4')}`;
export const ProcurementPoTutorialVideo = `${DownloadUrlPrefix}${encodeURIComponent('ProcurementPoTutorial.mp4')}`;
export const ProcurementRfqTutorialVideo = `${DownloadUrlPrefix}${encodeURIComponent('ProcurementRfqTutorial.mp4')}`;
